
/**
 * Google Analytics utility functions for tracking page views and events
 */

/**
 * Track a page view in Google Analytics
 * @param path The path to track
 * @param title The page title
 */
export const trackPageView = (path: string, title?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-T411Q1TYHE', {
      page_path: path,
      page_title: title
    });
    console.log(`📊 Analytics: Page view tracked for ${path}`);
  }
};

/**
 * Track an event in Google Analytics
 * @param action The event action
 * @param category The event category
 * @param label The event label
 * @param value The event value
 */
export const trackEvent = (
  action: string,
  category?: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
    console.log(`📊 Analytics: Event tracked - ${action}`);
  }
};
